import { render, staticRenderFns } from "./CodewordSetsAdmin.vue?vue&type=template&id=251ec5a0&scoped=true&"
import script from "./CodewordSetsAdmin.vue?vue&type=script&lang=js&"
export * from "./CodewordSetsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CodewordSetsAdmin.vue?vue&type=style&index=0&id=251ec5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ec5a0",
  null
  
)

export default component.exports